






















import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class InuptClientType extends Vue {
  public get clientType(){
    return this.$store.state.clientType;
  }
  public setClientType(clientType: string){
    this.$store.dispatch('setClientType',clientType)
  }
}
